import { useQuery } from '@tanstack/react-query';
import { getCourseAssignmentTeamDetailsFromClient } from '~/pages/api/courses/assignments/team/getCourseAssignmentTeamDetails.api';

const KEY = 'team-course-assignment';

export function getTeamCourseAssignmentKey() {
   return [KEY];
}

export function useCourseAssignmentTeamDetails(course_assignmentid: number | null) {
   const queryFunction = async () => {
      return await getCourseAssignmentTeamDetailsFromClient(course_assignmentid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: [KEY, course_assignmentid],
   });
}
